import React, { Component } from 'react';
import {
  _ViewConvo,
  _UserDetails,
  _AgentQueueHistory,
  _conversationHistory,
} from './models';
// import { chatActionMap } from '../constants';
import Modal from '../CommonComponents/Modal';
import ConversationHistory from './ConversationHistory';
import { api } from '../utils';
import WebsChannel from '../assets/icons/webs_channel.svg';
import WhatsappChannel from '../assets/icons/whatsapp_channel.png';
import LoaderGIF from '../assets/icons/logout-loader.gif';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import _moment, { Moment } from 'moment';
import FileDownloadIcon from '../assets/icons/file-download.svg';
import { BASE_URL, HTTP_URL } from '../constants';

type Props = {
  conversations: _ViewConvo[];
  onClose: Function;
  backBtnIcon: string;
  selectedbotIcon: string;
  selectedbotName: string;
  showLoader: boolean;
  selectedBotid: string;
  botID: string;
  startDate: Moment;
  endDate: Moment;
  utcstartDate: any;
  utcendDate: any;
  selectedSource: any;
  selectedAgent: any;
  selectedQueue: any;
  title: any | string;
};
type State = {
  showConvoHistory: boolean;
  custID: string;
  queueName: string;
  agentName: string;
  userDetails: _UserDetails[];
  agentQueueHistory: _AgentQueueHistory[];
  conversationHistory: _conversationHistory[];
};

export default class ConversationList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.agentQueueHistory = this.agentQueueHistory.bind(this);
    this.conversationHistory = this.conversationHistory.bind(this);
    this.getUserdownloadAnalytics = this.getUserdownloadAnalytics.bind(this);
  }

  setInitialState(): State {
    return {
      showConvoHistory: false,
      custID: '',
      queueName: '',
      agentName: '',
      userDetails: [],
      agentQueueHistory: [],
      conversationHistory: [],
    };
  }
  convHistory = (session_id: string) => {
    api(
      `getConvHistory?sessionId=${session_id}&timezoneOffset=${new Date().getTimezoneOffset()}&agentSessionID=${sessionStorage.getItem(
        'agentActiveSession'
      )}`
    ).then((response) => {
      let user = response.convHistory[0].section1.userDetails;
      let splitUser = user.split('~$$$~');
      this.setState(
        {
          userDetails: [
            {
              name: splitUser[0],
              email: splitUser[2],
              contact_no: splitUser[1],
              session_start_time: splitUser[3],
              channel: splitUser[4],
              deviceInfo: splitUser[5],
            },
          ],
          agentQueueHistory: this.agentQueueHistory(
            response.convHistory[1].section2.userHistory
          ),
          conversationHistory: this.conversationHistory(
            response.convHistory[2].section3.chat
          ),
        },
        () => {
          // console.log(this.state.userDetails)
        }
      );
    });
  };
  agentQueueHistory = (data: string): _AgentQueueHistory[] => {
    const list = data && JSON.parse(JSON.stringify(data));
    if (list && list) {
      return list.map((conv: any) => ({
        userFeedback: conv.userFeedback || '-',
        agent_feedback: conv.agent_feedback || '-',
        userComment: conv.userComment || '-',
        handoff_trigger: conv.handoff_trigger || '-',
        handoff_trigger_time: conv.handoff_trigger_time || '-',
        actionList: conv.actionArray || '-',
        row: conv.row || '-',
        status: conv.status || '-',
      }));
    } else {
      return [];
    }
  };
  conversationHistory = (data: string): _conversationHistory[] => {
    const list = data && JSON.parse(JSON.stringify(data));
    if (list && list) {
      return list.map((conv: any) => ({
        agentid: conv.agentid || '-',
        botIconURL: conv.botIconURL || '-',
        source: conv.source || '-',
        time: conv.time || '-',
        message: conv.message || '-',
        agentName: conv.agentName || '-',
        disambQuestions: conv.disambQuestions || '-',
        date: conv.date || '-',
      }));
    } else {
      return [];
    }
  };

  getUserdownloadAnalytics() {
    let analyticsBotid = '';
    if (this.props.selectedBotid !== '') {
      analyticsBotid = this.props.selectedBotid;
    } else {
      analyticsBotid = this.props.botID;
    }
    let datachannel = '';
    if (this.props.selectedSource.name.indexOf('Web') > -1) {
      datachannel = 'webs';
    } else if (this.props.selectedSource.name === 'WhatsApp') {
      datachannel = 'whatsapp';
    } else {
      datachannel = this.props.selectedSource.name;
    }

    fetch(
      `${HTTP_URL}${BASE_URL}/downloadUserHistory?start=${
        this.props.utcstartDate //uat
        // `https://${BASE_URL}/downloadUserHistory?start=${
        // this.props.utcstartDate //prod
      }&end=${this.props.utcendDate}&agentId=${this.props.selectedAgent.id}&queueId=${
        this.props.selectedQueue.id
      }&channel=${datachannel}&deviceInfo=${
        this.props.selectedSource.deviceInfo
      }&cardName=${this.props.title}&botId=${encodeURIComponent(
        analyticsBotid
      )}&timezoneOffset=${new Date().getTimezoneOffset()}&agentSessionID=${sessionStorage.getItem(
        'agentActiveSession'
      )}`,
      {
        method: 'GET',
      }
    )
      .then((response) => response.blob())

      .then((blob) => {
        // this.props.downloadToaterNotify('Your download will start in a few seconds');
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `report_${new Date().getTime()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  }

  render() {
    return (
      <div id='conversation-list-wrapper'>
        <div className='agent-ranking-header'>
          <div
            onClick={() => {
              this.props.onClose();
            }}
            className='bac-to-prev-screen'>
            <img src={this.props.backBtnIcon} alt='backicon' />
            Back
          </div>
          <div className='agent-ranking-sub-header'>
            <div style={{ marginLeft: '26px' }}>Chats</div>

            {this.props.selectedbotName && this.props.selectedbotIcon && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <img
                  src={this.props.selectedbotIcon}
                  alt='botIcon'
                  style={{ width: '46px', height: '46px', marginRight: '10px' }}
                />
                <div>{this.props.selectedbotName}</div>
              </div>
            )}
          </div>
        </div>
        {/* <div
             style={{display:'flex',
             flexDirection:'column',
             margin: '24.5px 38px 0px 38px',
             height: 'calc(100% - 87.5px - 24.5px)',
             justifyContent:'end'}}
             > */}

        {this.props.showLoader ? (
          <div
            className='showloadergif'
            style={{
              width: '100%',
              height: 'calc(100% - 87.5px - 24.5px)',
              // height: '100%',
              // margin: '24.5px 38px 0px 38px',
              // overflowX: 'auto',
            }}>
            <div className='loader-inner'>
              <img src={LoaderGIF} alt='loader' className='loader-icon' />
              <span className='loader-content'>Loading data</span>
            </div>
          </div>
        ) : (
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                margin: '24.5px 38px 0px 38px',
                width: '95%',
              }}>
              <div
                className='download-icon'
                title='Download data'
                onClick={this.getUserdownloadAnalytics}>
                <img src={FileDownloadIcon} alt='Data Download' />
              </div>
            </div>

            <div
              style={{
                margin: '24.5px 38px 0px 38px',
                width: '95%',
                overflow: 'scroll',
                height: 'calc(100% - 227.5px)',
              }}>
              <div id='list-header'>
                <div style={{ width: '110px' }}>S.No</div>
                <div style={{ width: '150px' }}>Session ID</div>
                <div style={{ width: '195px' }}>User details</div>
                <div style={{ width: '118px' }}>Source</div>
                <div style={{ width: '150px' }}>Handoff Time</div>
                <div style={{ width: '175px' }}>User wait time in queue </div>
                <div style={{ width: '324px' }}>Queue & agent history</div>
                <div style={{ width: '113px' }}>Status</div>
                <div style={{ width: '106px' }}>Agent Comment</div>
                <div style={{ width: '151px' }}>User feedback</div>
                <div style={{ width: '204px' }}>User comment</div>
                <div style={{ width: '205px' }}>referer</div>
              </div>
              <div id='list-content'>
                {this.props.conversations.map((conv, index) => {
                  let userDetails = conv.userDetails.split('~$$$~');
                  let history = conv.actionHistory.split('~$$$~');
                  return (
                    <div
                      key={index}
                      className='list-row clickable'
                      onClick={() => {
                        this.setState({
                          showConvoHistory: true,
                        });
                        this.convHistory(conv.session_id);
                      }}>
                      <div
                        style={{
                          maxWidth: '80px',
                          width: '104px',
                          paddingRight: '24px',
                        }}>
                        {index + 1}
                      </div>
                      <div
                        style={{
                          maxWidth: '120px',
                          width: '144px',
                          paddingRight: '24px',
                        }}>
                        {conv.session_id}
                      </div>
                      <div
                        style={{
                          whiteSpace: 'pre-wrap',
                          maxWidth: '170px',
                          paddingRight: '24px',
                          width: '194px',
                        }}>
                        {
                          <div>
                            <div>{userDetails[0] === 'null' ? '-' : userDetails[0]}</div>
                            <div>{userDetails[1] === 'null' ? '-' : userDetails[1]}</div>
                            <div style={{ textTransform: 'none' }}>
                              {userDetails[2] === 'null' ? '-' : userDetails[2]}
                            </div>
                          </div>
                        }
                      </div>
                      <div style={{ display: 'flex', marginTop: '1px' }}>
                        <img
                          src={
                            conv.channel === 'webs'
                              ? WebsChannel
                              : conv.channel === 'whatsapp' || conv.channel === 'WhatsApp'
                              ? WhatsappChannel
                              : ''
                          }
                          alt=''
                          style={{ width: '20px', height: '20px' }}
                        />
                        <span style={{ marginLeft: '8px' }}>
                          {/* {conv.channel==="webs" ? 'Web' : 'whatsApp' }  */}

                          {userDetails[4] === 'webs' &&
                          (userDetails[5] === null ||
                            userDetails[5] === '-' ||
                            userDetails[5] === '' ||
                            userDetails[5] === undefined)
                            ? 'Web'
                            : userDetails[4] === 'webs'
                            ? `Web ${
                                userDetails[5] !== null ||
                                userDetails[5] !== '' ||
                                userDetails[5] !== undefined
                                  ? '(' + userDetails[5] + ')'
                                  : ''
                              }`
                            : userDetails[4] === 'whatsapp'
                            ? 'WhatsApp'
                            : userDetails[4]}
                        </span>
                      </div>
                      <div
                        style={{
                          maxWidth: '140px',
                          width: '164px',
                          paddingRight: '24px',
                        }}>
                        {conv.handOffTime}
                      </div>
                      <div
                        style={{
                          maxWidth: '140px',
                          width: '164px',
                          paddingRight: '24px',
                        }}>
                        {conv.waitingTime}
                      </div>
                      <div
                        style={{
                          width: '324px',
                        }}>
                        <ul
                          style={{
                            display: 'contents',
                            maxWidth: '300px',
                          }}>
                          {history.map((test, index) => {
                            return (
                              <li key={index} style={{ marginLeft: '13px' }}>
                                {test}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div
                        className={`status-history ${
                          conv.status === 'RESOLVED'
                            ? 'resolved-status'
                            : conv.status === 'ABANDON'
                            ? 'abandoned-status'
                            : conv.status === 'UNRESOLVED'
                            ? 'unresolved-status'
                            : ''
                        }`}
                        style={{ marginRight: '50px' }}>
                        {conv.status}
                      </div>
                      <div>{conv.agentComment}</div>
                      <div
                        style={
                          conv.userFeedback === 'POSITIVE'
                            ? {
                                fontSize: '10px',
                                fontWeight: 600,
                                letterSpacing: '0.15px',
                                lineHeight: '1.8',
                                color: '#009f17',
                              }
                            : {
                                fontSize: '10px',
                                fontWeight: 600,
                                letterSpacing: '0.15px',
                                lineHeight: '1.8',
                                color: '#ff0000',
                              }
                        }>
                        {conv.userFeedback}
                      </div>
                      <div
                        style={{
                          maxWidth: '180px',
                          paddingRight: '24px',
                          width: '204px',
                        }}>
                        {conv.comment}
                      </div>
                      <div
                        style={{
                          maxWidth: '180px',
                          paddingRight: '24px',
                          width: '205px',
                        }}>
                        {conv.referer}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}

        {/* </div> */}

        {/* changed */}
        {this.state.showConvoHistory ? (
          <Modal
            innerStyle={{ paddingBottom: 0 }}
            isOpen={this.state.showConvoHistory}
            title='Chat details'
            showBorders='true'
            onClose={() => {
              this.setState({
                showConvoHistory: false,
              });
            }}>
            <ConversationHistory
              custID={this.state.custID}
              userDetails={this.state.userDetails}
              actionHistory={this.state.agentQueueHistory}
              conversationHistory={this.state.conversationHistory}
            />
          </Modal>
        ) : null}
      </div>
    );
  }
}
